{
  "brand": "Yexzabel by Grace",
  "phoneWA": "56989274098",
  "phoneDisplay": "+56 9 8927 4098",
  "city": "Viña del Mar · Valparaíso",
  "email": "hola@yexzabelbygrace.cl",
  "hours": "Lun–Vie 10:00–19:00 · Sáb 10:00–14:00",
  "slots": ["10:00", "11:00", "12:00", "13:00", "15:00", "16:00", "17:00", "18:00", "19:00"],
  "closedWeekdays": [0],
  "featuredServices": ["semi", "kapping", "polygel", "pestanas"],
  "categories": ["Uñas", "Skin Care", "Pestañas"]
}
